import React from "react";
import { Localize } from "components/service";
import { getStaffAuditAccuracyQuality } from "../helpers/staff-audit-log-presentation-helper";


const activeBarsByQuality = { good: 4, warning: 2, poor: 1, unknown: 0 };

const StaffAuditAccuracyIcon = ({ quality }) => (
    <svg
        className="staff-audit-accuracy__icon"
        width="16"
        height="16"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false">
        { [ 4, 8, 12, 16 ].map((height, index) => (
            <rect
                key={ height }
                className={ index < activeBarsByQuality[ quality ] ? "staff-audit-accuracy__bar--active" : undefined }
                x={ 2 + index * 4 }
                y={ 18 - height }
                width="2.5"
                height={ height }
                rx="0.5" />
        )) }
        { quality === "unknown" &&
            <line className="staff-audit-accuracy__slash" x1="1" y1="2" x2="18" y2="19" />
        }
    </svg>
);

const StaffAuditAccuracyField = ({ accuracy }) => {
    const quality = getStaffAuditAccuracyQuality(accuracy);
    const hasAccuracy = quality !== "unknown";

    return (
        <span
            className={ `staff-audit-accuracy staff-audit-accuracy--${ quality }` }
            title={ hasAccuracy ? `${ accuracy } m` : undefined }>
            <span className="staff-audit-accuracy__status">
                <StaffAuditAccuracyIcon quality={ quality } />
                <span className="staff-audit-accuracy__label">
                    <Localize>{ `STAFF_MANAGEMENT.AuditAccuracy_${ quality }` }</Localize>
                </span>
            </span>
            <span className="staff-audit-accuracy__value">
                { hasAccuracy ? `${ Number(accuracy.toFixed(1)) } m` : "—" }
            </span>
        </span>
    );
};

export default StaffAuditAccuracyField;
